import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertError32Icon extends BaseIcon {
  getChildren = () => [
    <path d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0z" fill="#f24e4e"/>,
    <path d="M23.7 22.3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L16 17.4l-6.3 6.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l6.3-6.3-6.3-6.3c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l6.3 6.3 6.3-6.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4L17.4 16l6.3 6.3z" fill="#fff"/>
    ]
  getViewBox = () => '0 0 32 32'
}
